import km from 'keymirror'
import _ from 'underscore'

export default _.extend({}, km({
  GET_USER_CARD_LIST_SUCCESS: null,
  GET_USER_CARD_LIST_ERROR: null,
  GET_NEW_CARD_BILL_LIST_SUCCESS: null,
  GET_NEW_CARD_BILL_LIST_ERROR: null,
}))